/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { endConversation } from '$lib/apis/webchat/endConversation';
import { sessionTimeout, chatSession, chatStartTime, connectedToAgent, entryMessage, reInitializeChat, surveySent, virtualAgentDisconnectMessageSent, displayDisconnectWarning, displayDisconnect, conversationTimeout, is_start_loading } from '$lib/stores/chatSessionStore';
import { socketDisconnect, socketState } from '$lib/stores/websocketStore';
import { get } from 'svelte/store';
import type { BRAND_ABRV } from './brandingConfigurations';

export const endConversationLogic = async () => {
	const chatSessionData = get(chatSession)
	await endConversation({ conversationId: chatSessionData.conversation_id, brand: chatSessionData.brand, browser_uuid: chatSessionData.brand }, chatSessionData.token);
	cleanUpStores();
};

export const cleanUpStores = () => {
	const socket = get(socketState)
	reInitializeChat.set(true);
	chatSession.set({
		agent: 'flora',
		conversation_id: '',
		token: '',
		auth: false,
		deviceType: '',
		operatingSystem: '',
		flags: [],
		firstName: '',
		lastName: '',
		channel: '',
		entry_point: '',
		entry_page_type: '',
		brand: '' as BRAND_ABRV,
		email: '',
		contactId: '',
		enterpriseId: '',
		browseruuid: '',
		loyaltyStatus: '',
		passportEndDate: '',
		parentViewPortHeight: '',
		currentUrl: '',
		transferCounter: 0,
		cartOrderDetails: {
			isItemAdded: '',
			orderValue: '',
			orderNumber: '',
			wasOrderPlaced: '',
			cartHasPassport: ''
		},
		messages: [],
		chatHistory: [],
		disconnectTimer: null,
		reconnectAttempts: 0,
		reconnectFailureMessageSent: false
	});
	entryMessage.set({ suggestion: '', type: '' });
	surveySent.set(false);
	sessionTimeout.set(false);
	if (socket && socket?.socket?.readyState === socket?.socket?.OPEN) {
		socketDisconnect();
	}
	connectedToAgent.set(false);
	chatStartTime.set('');
	virtualAgentDisconnectMessageSent.set(false);
	displayDisconnectWarning.set(false);
	displayDisconnect.set(false)
	conversationTimeout.set(false)
	is_start_loading.set(false)
	sessionStorage.removeItem('conversation');
	sessionStorage.removeItem('entryMessage');
}

